<template>
    <div id="productImageList">
      <div class="searchField">
        <span class="searchButton">{{translations.wsm_Search}}</span>
        <input v-model="productSearchName" class="search" :placeholder= "translations.wsm_SearchboxPro" type="text" :debounce-time="100" />
        <div v-if="!!getCategories.length">
          <div @click="toggleSettings()" class="filterIcon"><i class="fa fa-caret-down fa-2x" aria-hidden="true"></i>
          </div>
           <FilterProduct 
              :cat="getCategories"
              v-if="showSettings"
              @setSelectedCat="setSelectedCat"
              :saveCat="selectedCat"
            >
            </FilterProduct>
        </div>
      </div>
      
      <div  v-if="!productSearchName" class="container">
        <div class="productHeader" v-for="product in images">
          <div v-if="product.name">
            <h2 v-html="(product.name)"></h2>
          </div>
          <div v-else>
            <h2>{{translations.wsm_proProducts}}</h2>
          </div>  
          <Loaders :is-visible="isLoading" />
          <div v-if="!isLoading" class="listWrap1">
            <div v-for="image in getImagesBySortNo(product.sortNo)">
                <div class="productImageWrap">
                  <a class="fancybox" :href="imageUrl(image.imageUrl, image.sortNo)" :title="image.name">
                    <v-lazy-image :src="imageUrl(image.imageUrl, image.sortNo)" :alt="image.name" />
                  </a>
                  <p v-html="(image.name)"></p>
                  <div id="productQuantity">(<span id="pQ" v-html="(image.quantityString)"/>)</div>
                  <div v-if="showDownloadOptions(image.productId)" class="imageLinkWrap">
                      <a :title="image.name" :href="checkImageUrl(image.imageUrl, 'th')" download>Download (150px)</a>
                      <a :title="image.name" :href="checkImageUrl(image.imageUrl, 'th2')" download>Download (250px)</a>
                      <a :title="image.name" :href="checkImageUrl(image.imageUrl, 'th3')" download>Download (640px)</a>
                      <a :title="image.name" :href="checkImageUrl(image.imageUrl, 'th4')" download>Download (980px)</a>
                      <div v-if="showFrontBackDownloadOption(image.productId)">
                        <a :title="image.name" :href="fetchFrontImage(image.sku_no || '')" download>Download ({{translations.wsm_FrontPage}})</a>
                        <a :title="image.name" :href="fetchBackImage(image.sku_no || '')" download>Download ({{translations.wsm_backPage}})</a>
                      </div>
                  </div>
                  <div v-else class="imageLinkWrap">
                      <a :title="image.name" :href="image.imageUrl" download>Download Image</a>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="productHeader">
        <Loaders :is-visible="isLoading" />
          <div v-if="!isLoading" class="listWrap1">
                <div v-for="image in images" class="productImageWrap">
                  <a class="fancybox" 
                    :href="imageUrl(image.imageUrl, image.sortNo)" 
                    :title="image.name"
                  >
                    <v-lazy-image :src="imageUrl(image.imageUrl, image.sortNo)" :alt="image.name"/>
                  </a>
                  <p v-html="(image.name)"></p>
                  <div id="productQuantity">(<span id="pQ" v-html="(image.quantityString)"/>)</div>
                  <div v-if="showDownloadOptions(image.productId)" class="imageLinkWrap">
                    <a class="fancybox" :title="image.name" :href="checkImageUrl(image.imageUrl, 'th')">Download (150px)</a>
                    <a class="fancybox" :title="image.name" :href="checkImageUrl(image.imageUrl, 'th2')">Download (250px)</a>
                    <a class="fancybox" :title="image.name" :href="checkImageUrl(image.imageUrl, 'th3')">Download (640px)</a>
                    <a class="fancybox" :title="image.name" :href="checkImageUrl(image.imageUrl, 'th4')">Download (980px)</a>
                    <div v-if="showFrontBackDownloadOption(image.productId)">
                      <a class="fancybox" :title="image.name" :href="fetchFrontImage(image.sku_no || '')">Download ({{translations.wsm_FrontPage}})</a>
                      <a class="fancybox" :title="image.name" :href="fetchBackImage(image.sku_no || '')">Download ({{translations.wsm_backPage}})</a>
                    </div>
                  </div>
                  <div v-else class="imageLinkWrap">
                      <a :title="image.name"  class="fancybox" :href="image.imageUrl">Download Image</a>
                  </div>
                </div>
              </div>    
            </div>
      </div>
</template>

<script>
  import FilterProduct from './filterProduct.vue';
  import Loaders from './loader.vue';
  import * as Bowser from "bowser";
  var imageHandler = require('../../../globalComponents/fetchImageUrl');
  const fallBackBrowserVersions = {
    Chrome : 31,
    Edge : 17,
    Safari : 15.6,
    Firefox : 64,
    Opera : 18,
    AndriodBrowser : 4.1,
    KaiOSBrowser : 2.5
  };

  export default {
      name : "ProductList",
      props : {
        translations : {},
        settings : {},
        flaptype : "",
        hidecat : ""
      },
      data() {
          return {
              productImages : {},
              isLoading : false,
              productSearchName : "",
              showSettings : false,
              selectedCat : "All",
          };
      },
      mounted() {
          this.geProductDetails();
      },
      methods: {
        setSelectedCat(cat){
          this.selectedCat = cat;
          this.showSettings = false;
        },
        toggleSettings(){
          this.showSettings = !this.showSettings;
        },
        getImagesBySortNo(sortNo){
          const products = this.productImages.productsByAttribute
            .filter((p) => p.sortNo === sortNo)
            .map((p) => p.globalProducts.map((g) => g.products))
            .flat(1)
          return products.flat(1);
        },
        async geProductDetails() {
          try {
              this.isLoading = true;
              const response = await this.$axios.post(`${basedir}/ajaxRequestServlet?mode=Search`, 
                {
                  isPointShop: false, 
                  target: { 
                    products: 
                    {
                      noOfResults: 99999, isProductOverview: true 
                    } 
                  }, 
                  attributeValueIds: [],
                  blacklistedAttributeValueIds: !!this.hidecat ? [this.hidecat] : [] 
                },
                { headers: {
                    "Content-type": "application/json",
                    "Cache-Control": "no-cache",
                    "Pragma": "no-cache",
                    "Expires": "0",
                  } 
                }
              );
                const productImages = response.data;
                this.productImages = {...productImages};
                this.isLoading = false;
              }
          catch {
            this.isLoading = false;
            return "Something went wrong";
          }
        },
        imageUrl(imageUrl, sortNo){
          const productIdsWithOutDownload = this.settings.showNoDownloads || [];
          if(productIdsWithOutDownload.includes(sortNo)){
            const url = this.checkImageUrl(imageUrl, 'th3');
            return url;
          }
          const url = this.checkImageUrl(imageUrl, 'th3');
          return url;
        },
        showDownloadOptions(sortNo){
          const productIdsWithOutDownload = this.settings.showNoDownloads || [];
          return !productIdsWithOutDownload.includes(sortNo);
        },
        showFrontBackDownloadOption(sortNo){
          const productIdsForExcludingFrontAndBack = this.settings.exculdeFrontBackId || [];
          return !productIdsForExcludingFrontAndBack.includes(sortNo);
        },
        fetchFrontImage(SKU) {
          return `${basedir}/productImageServlet/FRONT${SKU.trim()}.${this.isBrowserCompatableForWebPImages}`;
        },
        fetchBackImage(SKU) {
          return `${basedir}/productImageServlet/BACK${SKU.trim()}.${this.isBrowserCompatableForWebPImages}`;
        },
        fetchImage(imageId, size) {
          return  `${basedir}/productImageServlet/${imageId}${this.flaptype}.${size}.${this.isBrowserCompatableForWebPImages}`;
        },
        getHtmlString(quantity) {
          return `( ${quantity} )`;
        },
        isValidUrl(url) {
            return ["http://", "https://"].some(protocol => url.startsWith(protocol));
          },
        checkImageUrl(url, size) {
          const isValidUrl = this.isValidUrl(url);
          if (isValidUrl) {
              const reg = /.+?:\/\/.+?(\/.+?)(?:#|\?|$)/;
              const pathname = reg.exec(url)[1];
              const pathArray = pathname.split("/");
              const imageLInk = pathArray.length > 1 ? pathArray[2] : pathArray[1];
              const imageIdArray = imageLInk.split(".");
              const imageId=imageIdArray[0];
              if(isNaN(+imageId)){
                return url;
              }else{
                return this.fetchImage(`ID${imageId}`,size);
              }
          }else if((/((^ID|SKU)\d+|(^ID|SKU)\d+\.th\d.png)$/i).test(url)) {
            const imageIdArray= url.split(".");
            const imageId=imageIdArray[0];
            return this.fetchImage(imageId,size);  
          }else {
            return url;
          }
        },
      },
      computed: {
       isBrowserCompatableForWebPImages(){
          return Number(Bowser.version) > fallBackBrowserVersions[Bowser.name] ? "png" : "png";
       },
        images(){
          if(this.productSearchName){
            const allProducts = this.productImages.productsByAttribute.map((p) => {
              const products = p.globalProducts.map((g) => g.products);
              return products.flat(1);
            });
            return allProducts.flat(1).filter((p) => p.name.toLowerCase().includes(this.productSearchName.toLowerCase()));
          }
          if(this.selectedCat === "All"){
            return this.productImages.productsByAttribute;
          }else{
            return this.productImages.productsByAttribute.filter((p) => p.name === this.selectedCat);
          }
        },
        getCategories(){
          return this.productImages.useCategory ? this.productImages.productsByAttribute.map((p) => p.name) : [];
        }
      },
      components: { Loaders, FilterProduct }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  $small: 550px;
  $medium: 900px;
  #productImageList{
    margin-top:20px;
    .searchField{ 
      margin-bottom: 5px;
      display : flex;
      flex-direction: row;
      align-content: center;
      justify-content: flex-start;
      @media screen and (max-width: $small) {
        display:block;
      }
      .filterIcon{
        cursor:pointer;
        width:24px;
        height:24px;
        padding:8px;
        background:#004570;
        display:flex;
        align-items: center;
        justify-content: center;
        i.fa-caret-down{
          color:snow ;
        }
      
      }
    }
    
    .searchButton{
      width:auto;
      height:24px;
      padding:8px;
      background:#004570;
      display:inline-block;
      color:snow;  
    }
    .search{
      display: inline-block;
      background: #efefef;
      padding:11px;
      border:none;
      height:18px;
      max-width: 80%;
      margin-bottom: 16px;
      @media screen and (min-width: $small) {
        max-width: 182px;
      }
      
    }
    .container{
      
      align-items: center;
      flex-direction: column;
    }
    .productHeader{
      max-width:100%;
      margin-top: 0px;
      margin-bottom: 20px;
      padding:8px;
      .listWrap1{
        width: 90%;
        display:grid;
        grid-template-columns:1fr 1fr 1fr 1fr;
        align-items: center;
        @media screen and (max-width: 1000px){
          grid-template-columns:1fr 1fr 1fr;
        }
        @media screen and (max-width: 772px){
          grid-template-columns:1fr 1fr;
        }
        @media screen and (max-width: $small){
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }
      }
      .listWrap2{
        width: 90%;
        display:flex;
        flex-direction:row;
        align-items: center;
        justify-content: space-between; 
        @media screen and (max-width: $small){
          display: flex;
          flex-direction: column;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }
      }
      img{
        max-width: 100%;
      }
      h2 {
        background: #004570;
        color: white;
        padding: 6px;
        margin-left: -8px;
      }
      .productImageWrap{
        width: 100%;
        border: 2px solid lightgray;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 20px;
        vertical-align: top;
        border-radius: 7px;
        min-height: 400px;
        transition: all 0.4s ease;
        text-align: center;
        &:hover{
          background-color:#EFEFEF;
          border: 2px solid #054b77 ;
        }
        p{
          display: inline-block;
          font-size: 11px;
          font-weight: bold;
          padding:2px;
          text-align: center;
        }
        #productQuantity{
          display: flex;
          flex-direction: row;
          font-size: 11px;
          #pQ{
            font-size: 11px;
          }
        }
        @media screen and (min-width: $small) {
          width: 208px;
          img{
            max-height: 170px;
            max-width: 200px;
            display: block;
            margin: 0 auto;
            padding-top: 10px;
            padding-bottom: 10px;
          }
        }
        .imageLinkWrap{
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin: 5px;
          a{
            margin: 0;
            font-size: 13px;
            display:block;
          }
        }
      }
    }
  }

</style>
